import { styled } from '@styledComponents';
import { themeSpace, themeColor } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { BackgroundCloudImage } from '@components/BackgroundCloudImage';
import { dottedLinkStyles } from '@components/Link';

export const ContainerBox = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    padding: ${themeSpace(10)} ${themeSpace(7)}; /* 64px (4rem) top/bottom, 32px left/right */
  }
`;

export const FeatureCard = styled.div`
  width: 100%;
  margin-bottom: ${themeSpace(9)}; /* 48px between sections */
  display: flex;
  flex-direction: column;
  align-items: center; /* Center all content */
`;

export const FeaturePhoto = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  min-height: 56vw;
  max-height: 56vw;
  margin-top: ${themeSpace(7)}; /* 32px space after description */
  margin-bottom: ${themeSpace(7)}; /* 32px space before button */
  border-radius: 16px; /* Tablet default */
  ${themeMediaQuery('below_sm')} {
    border-radius: 12px; /* Mobile */
  }
  .featureBackgroundImg {
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }
  .featureBaseImg {
    width: 100%;
    position: absolute;
    left: 0;
  }
  .featureUiImg {
    width: 100%;
    position: absolute;
    left: 0;
  }
`;

export const FeatureTitle = styled(Text)`
  white-space: normal;
  margin-bottom: ${themeSpace(3)}; /* 8px space before description */
  max-width: 480px;
`;

export const FeatureDescription = styled(Text)`
  white-space: normal;
  max-width: 400px;
`;

export const FeatureButton = styled(CTALink)`
  ${dottedLinkStyles}
  color: ${themeColor('mono1')};
  font-size: 16px;
  font-weight: 500;
`;

export const FeatureImage = styled(BackgroundCloudImage)`
  background-color: ${themeColor('warmGray1')};
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
`;
